import { AlertScope } from "@fpsoftware/mvp";
import { EmptyLayout } from "@/layout/EmptyLayout";
import { AuthCard } from "./AuthCard";

export const PageAuth = () => {
  return (
    <EmptyLayout>
      <div style={{ width: "100%", maxWidth: "500px" }}>
        <AlertScope filter={["error"]}>
          <AuthCard />
        </AlertScope>
      </div>
    </EmptyLayout>
  );
};
